import React, { useEffect, useState } from "react";
import "../styles/HomePage.css";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ContactUs from "../Components/popup/HomePage/ContactUs";
import { HiOutlineMenu } from "react-icons/hi";
import { CgClose } from "react-icons/cg";
// import Calendly from "../Components/popup/HomePage/Calendly";

function HomePage() {
  const [open, setOpen] = useState(false);
  const [isFixed, setIsFixed] = useState(false);

  const [respMenu, setRespMenu] = useState();

  const navigate = useNavigate();
  const { data } = useSelector((state) => state.authUser?.data);

  useEffect(() => {
    const handleScroll = () => {
      setIsFixed(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header id="header" className={isFixed ? "headerFixed" : ""}>
        <div class="container">
          <div class="row align-items-center">
            <div class="col-4 col-md-4 col-lg-12 col-xl-2">
              <a href="#banner">
                <img class="img-fluid" src="img/logo.png" />
              </a>
            </div>
            <div class="col-8 col-md-8 col-lg-12 col-xl-10">
              <div class="menuList">
                <button className="respMenu" onClick={() => setRespMenu(!respMenu)}>
                  {respMenu ? <CgClose size={36} /> : <HiOutlineMenu size={36} />}
                </button>
                <ul className={respMenu ? "showMenu" : ""}>
                  <li>
                    <a href="#whatWillYouGet">What You Get</a>
                  </li>
                  <li>
                    <a href="#retail">Retail</a>
                  </li>
                  <li>
                    <a href="#cafesRestaurants">Cafes and Restaurants</a>
                  </li>
                  <li>
                    <a href="#health">Health</a>
                  </li>
                  <li>
                    <a href="#education">Education</a>
                  </li>
                  <li>
                    <a href="#whyChooseUs">Why Choose Us</a>
                  </li>
                </ul>
                <div class="loginBtns">
                  <a
                    class="login codepenButton"
                    onClick={() => navigate(data ? "/dashboard" : "/sign-in")}
                  >
                    <span>{data ? "Dashboard" : "Log in"}</span>
                  </a>
                  <a href="#specialOffer" class="offer codepenButton">
                    <span>Special Offer</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <aside class="mainBanner" id="banner">
        <div class="container">
          <div class="row">
            <div class="col-xl-6 pe-xxl-5 mb-5 mb-xl-0">
              <h2>
                Get Your <br /> 1st Month FREE!
              </h2>
              <p class="my-3">
                Transform your existing camera infrastructure into a powerful, AI-driven
                surveillance solution. Monitor multiple locations, automate safety compliance, and
                streamline event detection—all from a single, intuitive dashboard.
              </p>
              <h5 class="mb-5">Experience Flowlinks in action—schedule your free demo today!</h5>
              <a
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                class="codepenButton"
                onClick={() => setOpen(true)}
              >
                <span>Lets Talk</span>
              </a>
            </div>
            <div class="col-xl-6 ps-5">
              <img class="img-fluid" src="img/banner-img.png" />
            </div>
          </div>
        </div>
      </aside>

      <section class="bannerFut">
        <div class="container-lg">
          <aside class="bnrContact">
            <ul>
              <li>
                <img src="img/Location-Icon.svg" />
                <div class="">
                  <h3>Pay Us a Visit</h3>
                  <p>3840 Park Avenue, STE C-205, Edison, NJ 08820</p>
                </div>
              </li>
              <li>
                <img src="img/phone-call-icon.svg" />
                <div class="">
                  <h3>Give Us a Call</h3>
                  <p>+1 (732) 354-1541</p>
                </div>
              </li>
              <li>
                <img src="img/mail-icon.svg" />
                <div class="">
                  <h3>Send Us a Message</h3>
                  <p>info@flowlinks.ai</p>
                </div>
              </li>
            </ul>
          </aside>
        </div>
      </section>

      <section class="willYouGet" id="whatWillYouGet">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-xl-4">
              <h2>What will you get</h2>
            </div>
            <div class="col-xl-8 ps-xl-5 pe-xl-5">
              <img class="img-fluid" src="img/what-will-you-get.png" />
            </div>
          </div>

          <div class="youGetCont">
            <div class="items">
              <h3>Customizable Dashboard</h3>
              <p>
                Arrange camera feeds in 2x2, 4x4, or any grid layout to monitor specific areas and
                locations.
              </p>
            </div>
            <div class="items">
              <h3>Real-Time Insights</h3>
              <p>
                Track customer behavior, staff productivity, and safety compliance with automated
                alerts and detailed reports.
              </p>
            </div>
            <div class="items">
              <h3>Multi-Device Access</h3>
              <p>View alerts and data on desktops, tablets, or smartphones for quick response.</p>
            </div>
          </div>

          <div class="text-center mt-5">
            <h5 class="mb-5">See how easy it is to customize your surveillance dashboard!</h5>
            <a
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              class="codepenButton"
              onClick={() => setOpen(true)}
            >
              <span>Lets Talk</span>
            </a>
          </div>
        </div>
      </section>

      <section class="industrySpecific" id="retail">
        <div class="container">
          <div class="row">
            <div class="col-xl-12 text-center mb-5">
              <h2>Industry-Specific Solutions</h2>
              <p class="subTitle">
                Explore how Flowlinks empowers your business with our interactive carousel below.
              </p>
            </div>

            <div class="col-xl-6 pe-xl-5 order-2 order-xl-1">
              <h3 class="mb-4">Retail Locations</h3>
              <ul class="iconListing">
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/customer-analysis.svg" /> Customer Analysis
                  </h4>
                  <p>
                    Monitor entry with virtual lines, analyze real-time and historical headcount,
                    queue times, and zone-wise behavior.
                  </p>
                </li>
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/staff.svg" /> Staff Monitoring
                  </h4>
                  <p>
                    Use facial recognition for attendance, track productivity, detect unproductive
                    behavior, and ensure uniform compliance.
                  </p>
                </li>
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/alert.svg" /> Alerts & Notifications
                  </h4>
                  <p>
                    Set custom alerts for sales, refunds, or discounts. Receive instant
                    notifications via SMS, email, or video.
                  </p>
                </li>
              </ul>
              <h5 class="mb-5">Discover how AI Vision optimizes retail operations!</h5>
              <a
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                class="codepenButton"
                onClick={() => setOpen(true)}
              >
                <span>Lets Talk</span>
              </a>
            </div>

            <div class="col-xl-6 ps-xl-5 mb-5 mb-xl-0 order-1 order-xl-2">
              <img class="img-fluid" src="img/retail-locations.png" />
            </div>
          </div>
        </div>
      </section>

      <section class="industrySpecific bgGradient" id="cafesRestaurants">
        <div class="container">
          <div class="row">
            <div class="col-xl-6 pe-xl-5 mb-5 mb-xl-0">
              <img class="img-fluid" src="img/cafes-restaurants.png" />
            </div>

            <div class="col-xl-6 ps-xl-5">
              <h3 class="mb-4">Cafes & Restaurants</h3>
              <ul class="iconListing">
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/kitchen.svg" />
                    Kitchen & Prep Area Monitoring
                  </h4>
                  <p>
                    Instantly detect spills, trash overflows, or open freezer/refrigerator doors,
                    and ensure hygiene and equipment compliance with smart alerts.
                  </p>
                </li>
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/customer-experience.svg" />
                    Customer Experience
                  </h4>
                  <p>
                    Monitor queue lengths and wait times to improve service speed, while analyzing
                    customer behavior to identify popular seating and interaction areas.
                  </p>
                </li>
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/staff-productivity.svg" />
                    Staff Productivity
                  </h4>
                  <p>
                    Track employee tasks such as stocking, cleaning, and quality checks, with
                    instant alerts for uniform or hygiene non-compliance.
                  </p>
                </li>
              </ul>
              <h5 class="mb-5">Discover how AI Vision optimizes retail operations!</h5>
            </div>

            <div class="col-12 mt-xl-5">
              <div class="text-center">
                <a
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  class="codepenButton"
                  onClick={() => setOpen(true)}
                >
                  <span>Lets Talk</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="industrySpecific" id="health">
        <div class="container">
          <div class="row">
            <div class="col-xl-6 pe-xl-5 order-2 order-xl-1">
              <h3 class="mb-4">Health & Fitness Centers</h3>
              <ul class="iconListing">
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/safety.svg" /> Safety & Compliance
                  </h4>
                  <p>
                    Monitor restricted areas for unauthorized access with instant alerts, and track
                    equipment usage and cleanliness to ensure hygiene standards.
                  </p>
                </li>
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/member-insights.svg" /> Member Insights
                  </h4>
                  <p>
                    Analyze traffic patterns and peak times to optimize staffing, with zone tracking
                    for busy areas like weight rooms and studios.
                  </p>
                </li>
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/staff-monitoring.svg" /> Staff Monitoring
                  </h4>
                  <p>
                    Ensure staff presence in assigned areas with automated alerts for safety
                    non-compliance or unattended zones.
                  </p>
                </li>
              </ul>
              <h5 class="mb-5">See how AI Vision enhances safety in fitness centers!</h5>
              <a
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                class="codepenButton"
                onClick={() => setOpen(true)}
              >
                <span>Lets Talk</span>
              </a>
            </div>

            <div class="col-xl-6 ps-xl-5 mb-5 mb-xl-0 order-1 order-xl-2">
              <img class="img-fluid" src="img/health.png" />
            </div>
          </div>
        </div>
      </section>

      <section class="industrySpecific bgGradient withPatternTutoring" id="education">
        <div class="container">
          <div class="row">
            <div class="col-xl-6 pe-xl-5 mb-5 mb-xl-0">
              <img class="img-fluid" src="img/tutoring-centers.png" />
            </div>

            <div class="col-xl-6 ps-xl-5">
              <h3 class="mb-4">Tutoring Centers</h3>
              <ul class="iconListing">
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/kitchen.svg" />
                    Safety Monitoring
                  </h4>
                  <p>
                    Detect incidents like fights or unauthorized access with customizable alerts,
                    ensuring restricted areas stay secure with targeted video notifications.
                  </p>
                </li>
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/customer-experience.svg" />
                    Attendance Tracking
                  </h4>
                  <p>
                    Use facial recognition to track staff and student check-in/out times, while
                    monitoring staff productivity to ensure student engagement.
                  </p>
                </li>
                <li>
                  <h4 class="d-flex gap-3 mb-2">
                    <img class="img-fluid" src="img/staff-productivity.svg" />
                    Custom Reporting
                  </h4>
                  <p>
                    Generate reports on attendance, session durations, and classroom activity, with
                    visualized data and tailored graphs for actionable insights.
                  </p>
                </li>
              </ul>
              <h5 class="mb-5">Explore smarter tutoring center management today!</h5>
            </div>

            <div class="col-12 mt-xl-5">
              <div class="text-center">
                <a
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  class="codepenButton"
                  onClick={() => setOpen(true)}
                >
                  <span>Lets Talk</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="whyChoseUs" id="whyChooseUs">
        <div class="container-lg">
          <h2>
            Why Choose Flowlinks
            <br />
            for AI Surveillance?
          </h2>

          <div class="whyChoseGrid">
            <div class="itemsBox">
              <h3>Seamless Integration</h3>
              <p>Works with your existing cameras—no costly upgrades needed.</p>
            </div>
            <div class="itemsBox">
              <h3>Custom Alerts</h3>
              <p>
                Set priority levels for incidents (e.g., fights, fires, intruders) and receive
                notifications via SMS, email, or video alerts.
              </p>
            </div>
            <div class="itemsBox">
              <h3>Data Visualization</h3>
              <p>
                Create user-friendly, visually appealing reports on any schedule—hourly, weekly, or
                custom. Display data in graphs tailored to your needs.
              </p>
            </div>
            <div class="itemsBox">
              <h3>Multi-Channel Access</h3>
              <p>Stay connected with alerts and reports on any device, anywhere.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="specialOffer withPatternOffer" id="specialOffer">
        <div class="container">
          <h2>Special Offer: 1st Month FREE!</h2>
          <p class="my-4">
            Sign up today and get your first month free to experience smarter, safer, and more
            efficient monitoring.
          </p>
          <a
            onClick={() => setOpen(true)}
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            class="demoNow"
          >
            Lets Talk
          </a>
        </div>
      </section>

      <footer>
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-md-4 col-lg-3">
              <a href="#">
                <img src="img/logo.png" />
              </a>
              <ul class="futSocal">
                <li>
                  <a href="#">
                    <img src="img/facebook.png" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="img/linkedin.png" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="img/twitter.png" />
                  </a>
                </li>
              </ul>
              <p class="copyRight">
                © 2025 FlowLinks, Inc. All <br class="d-none d-xl-block" />
                rights reserved.
              </p>
            </div>

            <div class="col-md-4 col-lg-5 mt-5 mt-md-0">
              <h3 class="mb-3 mb-md-4">Quick Links</h3>
              <ul class="futLinks">
                <li>
                  <a href="#whyChooseUs">Why Choose Us</a>
                </li>
                <li>
                  <a href="#whatWillYouGet">What You Get</a>
                </li>
                <li>
                  <a href="#retail">Retail</a>
                </li>
                <li>
                  <a href="#cafesRestaurants">Cafes and Restaurants</a>
                </li>
                <li>
                  <a href="#health">Health</a>
                </li>
                <li>
                  <a href="#education">Education</a>
                </li>
                <li>
                  <Link to={"/privacy-policy"}>Privacy Policy</Link>
                </li>
              </ul>
            </div>

            <div class="col-md-4 col-lg-3 mt-5 mt-md-0">
              <h3 class="mb-3 mb-md-4">Get in Tocuh</h3>
              <ul class="address">
                <li>
                  <img class="icon" src="img/envelop.svg" /> info@flowlinks.ai
                </li>
                <li>
                  <img class="icon" src="img/phone.svg" /> +1 (732) 354-1541
                </li>
                <li>
                  <img class="icon" src="img/marker.svg" /> 3840 Park Avenue, STE C-205, Edison, NJ
                  08820
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <ContactUs open={open} onClose={() => setOpen(false)} />

      {/* <Calendly /> */}
    </>
  );
}

export default HomePage;
